import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as daCategory from './da-category'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: daCategory.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.DaCategory, string>
for (const enumEntryName in common.DaCategory) {
  const potentialEnum =
    common.DaCategory[enumEntryName as keyof typeof common.DaCategory]
  if (common.DaCategory.isDaCategory(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.DaCategory.ALL.reduce(
  (prev, _daCategory) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_daCategory]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.DaCategory.getEntry(_daCategory),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.DaCategory as (typeof common.DaCategory)[K] extends common.DaCategory
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
